"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Actions_1 = require("../Actions");
var Client_1 = require("./Client");
var ExerciseClient = /** @class */ (function (_super) {
    __extends(ExerciseClient, _super);
    function ExerciseClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExerciseClient.prototype.setExerciseProps = function (data) {
        this.postMessage(Actions_1.default.SET_EXERCISE_PROPS, data);
    };
    return ExerciseClient;
}(Client_1.default));
exports.default = ExerciseClient;
//# sourceMappingURL=ExerciseClient.js.map